
import { useEffect, useState } from "react";
import SearchInput from "../SearchInput";
import {CalendarBar, Checkbox, Pagination, Table, Tag} from "omoplay";
import {getAllDateRange} from "../../libs/helper";
import {getOrdersStatistics} from "../../api/statistics/statistics.api";
import GenericBoard from "../form/GenericBoard";
import LoadingBlock from "../LoadingBlock";
const moment = require("moment");

const OnlineOrderUsers = () => {
  const [tableUsers, setTableUsers] = useState([])
  const [search, setSearch] = useState("")
  const [totalCount, setTotalCount] = useState(0)
  const [totalSales, setTotalSales] = useState(0)
  const [page, setPage] = useState(1);
  const [dateRange, setDateRange] = useState(getAllDateRange())
  const [isOffline, setOffline] = useState(false)
  // 조회 중에는 빈 표 대신 스피너를 보여준다(데이터 없음과 구분되지 않던 문제, 2026-08-05).
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState("")

  const limit = 10

  useEffect(() => {
    setLoading(true)
    setLoadError("")
    getOrdersStatistics(null, dateRange.startDate, dateRange.endDate, search, isOffline, page, limit)
        .then(({data}) => {
          if (data) {
            setTotalCount(data.totalCount)
            setTotalSales(data.totalSales)
            setTableUsers(data.users.map(user => {
              return [
                <div className="flex-col justify-center gap-4 h-full">
                  {
                    user.products.map(({imgUrl, code, name}) => {
                      if (!imgUrl) {
                        return <div className="ml-[72px]">{name}</div>
                      }
                      return (
                          <div className="flex-align-center gap-2">
                            <img src={imgUrl} className="w-16 h-16" />
                            <div className="text-primary pointer" onClick={() => productDetail(code) }>{name}</div>
                          </div>
                      )
                      })
                  }
                </div>,
                <div className={`flex-center-all h-full break-all ${user.id && 'text-primary pointer'}`}
                     onClick={() => {if (user.id) {userDetail(user.id)}}}>{user.name}</div>,
                <div className="flex-center-all h-full">
                  <Tag className="text-white" color={user.gender === "남성" ? "#708090" : (user.gender === "여성" ? "#FFC0CB" : "white")}>{user.gender}</Tag>
                </div>,
                <div className="flex-center-all h-full">{user.age}</div>,
                <div className="flex-center-all h-full"><Tag>{user.productStatus}</Tag></div>,
                <div className="flex-center-all h-full">{user.paymentAmount.toLocaleString()}원</div>,
                <div className="flex-center-all h-full text-center">{user.paymentDate}</div>,
              ]
            }))
          }
    })
        .catch((e) => {
          // 🔴 실패를 '0명 / 0원' 으로 보여주면 장애가 '데이터 없음' 으로 읽힌다.
          //    그래서 집계 표시 자체를 숨기고(아래 loadError 분기) 사유만 남긴다. (2026-09-11, D-8)
          setTableUsers([])
          setTotalCount(0)
          setTotalSales(0)
          setLoadError(e?.message || "조회 중 오류가 발생했습니다.")
        })
        .finally(() => setLoading(false))
  }, [page, search, dateRange, isOffline]);

  const handleSearchChange = (search) => {
    setPage(1)
    setSearch(search);
  };

  const onDateInput = (dateRange) => {
    setPage(1)
    setDateRange({
      startDate: moment(dateRange.startDate).format("yyyy-MM-DD"),
      endDate: moment(dateRange.endDate).format("yyyy-MM-DD")
    });
  };

  const headers = [
    { name: "상품명" },
    { name: "이름", align: "center", width: "100px" },
    { name: "성별", align: "center", width: "90px" },
    { name: "연령", align: "center", width: "110px" },
    { name: "주문 상태", width: "120px", align: "center" },
    { name: "결제 가격", width: "120px", align: "center" },
    { name: "결제 날짜", width: "120px", align: "center" },
  ];

  function userDetail(id) {
    window.location.href = `/user/detail?id=${id}`
  }

  function productDetail(productCode) {
    window.location.href = `/product/detail?productCode=${productCode}`
  }

  return (
    <>
      <div className="flex-col rounded w-full">
        <div className="flex items-start" style={{marginTop: "35px", gap: "24px"}}>
          <div style={{maxWidth: "405px", width: "405px"}}>
            <div style={{marginBottom: "9px"}}>
              <label className="search-label">검색어</label>
            </div>
            <SearchInput onSubmit={(text) => handleSearchChange(text)} />
          </div>
          <div>
            <div style={{marginBottom: "9px"}}>
              <label className="search-label">결제 날짜</label>
            </div>
            <CalendarBar initDate={{startDate: moment(dateRange.startDate).toDate(), endDate: moment(dateRange.endDate).toDate()}}
                         onConfirm={(props) => onDateInput(props)} />
          </div>
          <div>
            <div style={{marginBottom: "9px"}}>
              <label className="search-label">카카오 고객</label>
            </div>
            <div className="flex-center-all gap-2 h-[50px]">
              <div>카카오 고객만 보기</div>
              <div><Checkbox onChecked={(checked) => {
                setOffline(checked)
              }} /></div>
            </div>
          </div>
        </div>
        <div className="flex gap-8 mt-[30px] ml-[14px]">
          {/* 조회에 실패했거나 아직 불러오는 중이면 숫자를 '-' 로 둔다.
              0 을 그대로 보여주면 '주문이 없는 기간' 과 구분되지 않는다(2026-09-11, D-8). */}
          <span className="font-16px">
            총 <span className="mainblue-0">{(loading || loadError) ? "-" : totalCount.toLocaleString()}</span>명
          </span>
          <span className="font-16px">
            매출 <span className="mainblue-0">{(loading || loadError) ? "-" : totalSales.toLocaleString()}</span>원
          </span>
        </div>
        <div className="flex-col py-4">
          {(loading || loadError) ? (
            <LoadingBlock
              error={loadError}
              title="온라인 매출 정보를 지금은 불러올 수 없습니다."
              tone="notice"
            />
          ) : (
            <>
              <GenericBoard items={tableUsers} columns={[
                { align: 'left', flex: true },
                { align: 'right' },
                { align: 'right' },
                { align: 'right' },
                { align: 'right' }
              ]} />
              <div className="flex justify-center mt-[24px]">
                <Pagination pageSize={limit} totalCount={totalCount} currentPage={page} onPaging={(page) => setPage(page)} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default OnlineOrderUsers;
